import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type Props = {
  label?: string;   // Optional, default "Back"
  height?: number;
  url?:string 
};

export default function BackButton({ label = "back", height ,url}: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={() =>url? navigate(url):navigate(-1)} // Go back in history
      className={`
        flex items-center justify-center
        bg-secondary text-white
        px-6 ${height ? `h-[${height}px]` : "h-[44px]"}
        rounded-[8px] text-lg font-semibold
        transition hover:bg-opacity-85
      `}
    >
      {/* Optional left arrow icon */}
      <span className="mr-2">&#8592;</span>
      {t(label)}
    </button>
  );
}
